import React, {FC} from 'react';
import {Appointment} from 'components/ContentPagesComponents/TextHeader/query';
import {formatInTimeZone} from 'date-fns-tz';

import Success from './svgs/success.inline.svg';
import {useAppointments} from './query';

import * as styles from './styles.module.scss';

type TextHeaderProps = {
	title: string;
	altDescription: string;
	body: string;
	imageSrc?: string;
}

export const getRecentBooking = (apptList: Appointment[]): Appointment | undefined => {
	// Get booking that was made most recently, based on the reserve time for each appt
	const now = new Date();
	apptList.sort((a, b) => {
		return b.reservation.reserved.unix - a.reservation.reserved.unix;
	});

	if (apptList.length > 0) {
		// Will not show past appointments if the user stumbles onto the success page without booking an appt
		if (apptList[0].details.start.unix * 1000 > now.getTime()) {
			return apptList[0];
		}
	}
	return undefined;
};

export const TextHeader: FC<TextHeaderProps> = ({title, altDescription, body, imageSrc}) => {
	const data = useAppointments();
	let apptConfirmationMsg;

	if (data?.data?.auth.user) {
		const apptList = data.data?.auth.user.appts;
		const recentBooking = getRecentBooking(apptList);

		if (recentBooking) {
			const date = new Date(recentBooking.details.start.unix * 1000);
			const location = recentBooking.details.location.details.name;
			const timezone = recentBooking.details.start.timezone;
			apptConfirmationMsg = 'We\'re excited to see you at '
				+ formatInTimeZone(date, timezone, 'hh:mm a') + ' on '
				+ formatInTimeZone(date, timezone, 'MMM dd yyyy') + ' at '
				+ location + '!';
		}
	};

	return (
		<div className={styles.content}>
			<div className={styles.image}>
				{imageSrc ? <img src={imageSrc} /> : <Success />}
			</div>
			<div className={styles.text}>
				<h1>{title}</h1>
				{apptConfirmationMsg ? (
					<span>
						{apptConfirmationMsg}
					</span>
				) : (
					<span>{altDescription}</span>
				)}
				<span>{body}</span>
			</div>
		</div>
	);
};

export default TextHeader;
